import bemBlock from '@gik/core/utils/bemBlock';
import withComponentErrorBoundary from '@gik/core/utils/withComponentErrorBoundary';
import OtherWaysToSupport from '@gik/inkind-page/components/InkindSupportSidebar/OtherWaysToSupport';
import React from 'react';
import SupportButtons from './SupportButtons';

export interface IInkindSupportSidebarProps {
  inkindRouteId: string;
  isSamplePage?: boolean;
}

function InkindSupportSidebarComp({ inkindRouteId, isSamplePage }: IInkindSupportSidebarProps) {
  const bem = bemBlock('support-sidebar');

  return (
    <div className={bem()}>
      <SupportButtons inkindRouteId={inkindRouteId} isSamplePage={isSamplePage} />
      <OtherWaysToSupport />
    </div>
  );
}

export const InkindSupportSidebar = withComponentErrorBoundary(InkindSupportSidebarComp);
